import { theme as uiTheme } from '@mi-front/ui';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { THUMBNAIL_HEIGHT } from '../consts';
import { ThumbnailImageMetadata } from '../types';
import { calculateThumbnailDisplayRatio, calculateThumbnailFrameWidth } from '../utils';
import { ThumbnailFrame } from './ThumbnailFrame';

interface Props {
  metadata: ThumbnailImageMetadata;
  targetHeight?: number;
  theme?: 'dark' | 'light';
}

/**
 * Displays a placeholder for missing thumbnails with an image icon
 */
export function MissingThumbnail({
  metadata,
  targetHeight = THUMBNAIL_HEIGHT,
  theme = 'dark',
}: Props) {
  const displayRatio = calculateThumbnailDisplayRatio(metadata, targetHeight);
  const width = calculateThumbnailFrameWidth(metadata, displayRatio);

  return (
    <ThumbnailFrame>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: `${width}px`,
          height: `${targetHeight}px`,
          background: theme === 'dark' ? 'black' : uiTheme.aqua,
        }}
      >
        <ImageNotSupportedIcon
          sx={{
            color: '#999',
            fontSize: '1.25rem',
          }}
        />
      </div>
    </ThumbnailFrame>
  );
}
